
export const environment = {
  production: false,
  SOCKET_ENDPOINT: 'https://dev.dxconnect.lifesup.ai',
  SOCKET_CS_ENDPOINT: 'https://dev.dxconnect.lifesup.ai',
  SOCKET_MESSAGE_ENDPOINT: 'https://dev.dx-socket.lifesup.ai',
  baseUrl: window.location.origin,
  CHAT_ENDPOINT: 'https://dev.dxconnect.lifesup.ai'
};


